module.exports = __webpack_public_path__ + "img/search3.1113f890.jpg";